import { IRevenueAgencyPageLang } from '../../../types/lang'

export const revenueAgencyPageLang: IRevenueAgencyPageLang = {
	revenue_agency_page: {
		btn_add_new: 'Add New_ru',
	}
}